import React, { Fragment, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import DialogBoxComponent from "../../../../components/DialogBoxComponent";
import CircularProgress from "@mui/material/CircularProgress";
// import { fetchPolicyImportList, importPolicy } from "../helper";
import { Box, Stack, Typography } from "@mui/material";
import { useRiskAssessmentContext } from "../../../../context/RiskAssessment/RiskAssessmentContext";
import {
  createImport,
  getThreatSourctImportList,
} from "../../ThreatSource/helper";
import {
  createCyberSecurityRiskAssessment,
  createImportCyberSecurityRiskAssessment,
  importCyberSecurityRiskAssessment,
} from "../../helper";
import { useUserContext } from "../../../../context/auth/UserContext";
// import { AddThreatImport, EditThreat, IThreatImport } from "../modal";
// import { createImport, getThreatSourctImportList, updateIThreat}
// import { editPolicy } from "../helper";

// interface PolicyImportInterface {
//     policyID: number;
//     policyName: string;
//     policyContent: string;
//     version: string;
//     policyStatus: string;
//     approvalDate: Date;
// }

export const CSImport = (props: {
  openDialog: boolean;
  handleCancel: () => void;
  refreshList: () => void;
}) => {
  const { cyberRiskAssessmentList, setCyberRiskAssessmentList } =
    useRiskAssessmentContext();
  const { userId, companyProfileID } = useUserContext();

  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [importCsList, setImportCsList] = useState<any[]>([]);
  const [importCsListOrg, setImportCsListOrg] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openSuccessDialogBox: false,
  });
  const handleCloseDialog = () => {
    if (dialogState.title !== "Error") {
      setDialogState({
        ...dialogState,
        openSuccessDialogBox: false,
      });
      props.refreshList();
      handleClose();
    } else {
      setDialogState({
        ...dialogState,
        openSuccessDialogBox: false,
      });
    }
  };

  const handleToggle = (value: string) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectAll(false);
      setChecked([]);
    } else {
      setSelectAll(true);
      const newChecked = importCsList.map((ele) => ele.assessmentTemplateID);
      setChecked(newChecked);
    }
  };

  const handleClose = () => {
    if (props.handleCancel) {
      props.handleCancel();
    }
    setChecked([]);
    setSelectAll(false);
    setImportCsList([]);
    setImportCsListOrg([]);
    setOpen(false);
  };

  const fetchCsImport = async (companyProfileID: number) => {
    try {
      const res = await importCyberSecurityRiskAssessment(companyProfileID);
      const modRes = res.filter((item: { threatSourceName: string | null; }) => !!item.threatSourceName?.trim())

      const filteredRes = modRes.filter((resItem: any) => {
        return !cyberRiskAssessmentList.some(
          (existingItem: any) =>
            existingItem.threatSourceName === resItem.threatSourceName
        );
      });
      setImportCsList(filteredRes);
      setImportCsListOrg(modRes);
    } catch (error) {
      console.error("@@Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getSelectedImport = () => {
    return importCsList.filter((ele) =>
      checked.includes(ele.assessmentTemplateID)
    );
  };

  const handleImport = async () => {
    setIsLoading(true);
    const selectedImport = getSelectedImport();
    let hasError = false;
    const date = new Date();
    //Import new Controll
    const payload = selectedImport.map((ele) => {
      return {
        vulnerabilityId: ele.vulnerabilityId,
        controlId: ele.controlId,
        threatEventId: ele.threatEventId,
        threatSourceId: ele.threatSourceId,
        likelihoodId: ele.likelihoodId,
        adverseImpactId: ele.adverseImpactId,
        inherentRiskId: ele.inherentRiskId,
        residualRiskId: ele.residualRiskId,
        responseId: ele.responseId,
        comment: ele.comment,
        companyProfileID: companyProfileID,
        createDate: date,
        createdBy: userId,
        isDeleted: false,
      };
    });

    const resImport = await createImportCyberSecurityRiskAssessment(payload);
    if (!resImport.succeeded) {
      hasError = true;
    }

    if (hasError) {
      setIsLoading(false);
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openSuccessDialogBox: true,
      });
    } else {
      setIsLoading(false);
      setDialogState({
        title: "Success",
        body: "Risk successfully imported",
        action: "OK",
        actionCancel: "",
        openSuccessDialogBox: true,
      });
    }
  };

  useEffect(() => {
    setOpen(props.openDialog);
    setIsLoading(true);
    if (props.openDialog) {
      fetchCsImport(companyProfileID);
    }
  }, [props.openDialog]);

  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose} keepMounted>
        <DialogTitle sx={{ fontSize: "1.1rem" }}>Import Risks</DialogTitle>
        <DialogContent>
          {importCsList.length > 0 ? (
            <Stack direction="row" sx={{ mx: 2 }}>
              <Checkbox
                size="small"
                edge="start"
                checked={selectAll}
                onChange={handleSelectAll}
                tabIndex={-1}
                disableRipple
                sx={{ p: 0, mr: 3 }}
              />
              <span>Select All</span>
            </Stack>
          ) : null}

          <DialogContentText sx={{ height: "350px", overflowY: "scroll" }}>
            <List sx={{ width: "300px", bgcolor: "background.paper" }}>
              {!isLoading ? (
                importCsListOrg.length > 0 ? (
                  importCsList.length > 0 ? (
                    importCsList
                      .sort((a, b) => {
                        const nameA = a.threatSourceName || ''; // Use an empty string as fallback
                        const nameB = b.threatSourceName || '';
                        return nameA.localeCompare(nameB)
                      })
                      .map((ele) => {
                        const labelId = `checkbox-list-label-${ele}`;

                        return (
                          <ListItem
                            key={ele.assessmentTemplateID}
                            disablePadding
                            disableGutters
                          >
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle(ele.assessmentTemplateID)}
                              dense
                            >
                              <ListItemIcon sx={{ minWidth: "2rem" }}>
                                <Checkbox
                                  size="small"
                                  edge="start"
                                  checked={
                                    checked.indexOf(
                                      ele.assessmentTemplateID
                                    ) !== -1
                                  }
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                  sx={{ p: 0 }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                primary={ele.threatSourceName}
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })
                  ) : (
                    <Typography textAlign="center">
                      All the Risks are already imported.
                    </Typography>
                  )
                ) : (
                  <Typography textAlign="center">No Risk to import</Typography>
                )
              ) : (
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CircularProgress />
                </Box>
              )}
            </List>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "0.5rem 1.5rem" }}>
          <Button
            size="small"
            variant="contained"
            className="table-btn"
            disabled={isLoading}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={checked.length === 0 || isLoading}
            onClick={handleImport}
          >
            Import
          </Button>
        </DialogActions>
      </Dialog>

      {
        //success
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
    </Fragment>
  );
};
